<template>
  <footer class="site-footer">
    <!-- 加载中 -->
    <template v-if="!siteConfig || Object.keys(siteConfig).length === 0">
      <div class="footer-main">
        <div class="footer-inner">
          <div class="footer-skeleton" v-for="i in 3" :key="i">
            <a-skeleton :animation="true">
              <a-skeleton-line :rows="3" />
            </a-skeleton>
          </div>
        </div>
      </div>
    </template>
    
    <!-- 内容 -->
    <template v-else>
      <div class="footer-main">
        <div class="footer-inner">
          <!-- 左侧链接区 -->
          <div class="footer-nav">
            <div class="nav-group">
              <div class="group-label">关于</div>
              <router-link to="/about">关于我们</router-link>
              <router-link to="/page/agreement">使用协议</router-link>
              <router-link to="/page/privacy">隐私政策</router-link>
              <router-link to="/page/disclaimer">免责声明</router-link>
            </div>
            <div class="nav-group">
              <div class="group-label">服务</div>
              <router-link to="/page/supervision">监管措施</router-link>
              <router-link to="/page/dispute">纠纷处理</router-link>
              <span class="disabled-link">常见问题</span>
              <span class="disabled-link">联系客服</span>
            </div>
          </div>
          
          <!-- 右侧订阅区 -->
          <div class="footer-subscribe">
            <div class="subscribe-title">订阅最新资讯</div>
            <div class="subscribe-form">
              <input 
                type="email" 
                v-model="email" 
                placeholder="输入邮箱地址" 
                class="email-input"
              />
              <button class="subscribe-btn">订阅</button>
            </div>
          </div>
        </div>
      </div>
      
      <!-- 底部版权 -->
      <div class="footer-bottom">
        <div class="footer-inner">
          <span class="copyright">{{ siteConfig.copyright }}</span>
          <span class="records">
            <a 
              v-if="siteConfig.icp && siteConfig.icp.number" 
              :href="siteConfig.icp.url" 
              target="_blank"
            >{{ siteConfig.icp.number }}</a>
            <template v-if="siteConfig.other_records && siteConfig.other_records.length > 0">
              <a 
                v-for="(record, index) in siteConfig.other_records" 
                :key="index"
                :href="record.url" 
                target="_blank"
              >{{ record.number }}</a>
            </template>
          </span>
        </div>
      </div>
    </template>
  </footer>
</template>

<script>
import { getSiteConfig } from '@/api/index.js'

export default {
  name: 'PageFooter',
  data() {
    return {
      email: '',
      siteConfig: {}
    }
  },
  mounted() {
    this.loadSiteConfig()
  },
  methods: {
    async loadSiteConfig() {
      try {
        const result = await getSiteConfig()
        if (result.code === 1 && result.data) {
          this.siteConfig = result.data
        }
      } catch (error) {
        console.error('加载网站配置失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.site-footer {
  background: #1a1a1a;
  margin-top: 60px;
}

.footer-inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 16px;
}

/* 主体区域 */
.footer-main {
  padding: 40px 0;
}

.footer-main .footer-inner {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

/* 导航链接 */
.footer-nav {
  display: flex;
  gap: 80px;
}

.nav-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.group-label {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 6px;
}

.nav-group a,
.nav-group .disabled-link {
  font-size: 13px;
  color: #888;
  text-decoration: none;
  transition: color 0.2s;
}

.nav-group a:hover {
  color: #1890ff;
}

.nav-group .disabled-link {
  cursor: not-allowed;
  opacity: 0.5;
}

/* 订阅区 */
.footer-subscribe {
  text-align: right;
}

.subscribe-title {
  font-size: 14px;
  color: #888;
  margin-bottom: 12px;
}

.subscribe-form {
  display: flex;
  gap: 8px;
}

.email-input {
  width: 200px;
  padding: 8px 12px;
  font-size: 13px;
  border: 1px solid #333;
  border-radius: 4px;
  background: #222;
  color: #fff;
  outline: none;
  transition: border-color 0.2s;
}

.email-input::placeholder {
  color: #666;
}

.email-input:focus {
  border-color: #1890ff;
}

.subscribe-btn {
  padding: 8px 20px;
  font-size: 13px;
  color: #fff;
  background: #1890ff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s;
}

.subscribe-btn:hover {
  background: #40a9ff;
}

/* 底部版权 */
.footer-bottom {
  border-top: 1px solid #2a2a2a;
  padding: 16px 0;
}

.footer-bottom .footer-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.copyright {
  font-size: 12px;
  color: #555;
}

.records {
  display: flex;
  gap: 16px;
}

.records a {
  font-size: 12px;
  color: #555;
  text-decoration: none;
  transition: color 0.2s;
}

.records a:hover {
  color: #1890ff;
}

/* 骨架屏 */
.footer-skeleton {
  flex: 1;
}

/* 响应式 */
@media (max-width: 768px) {
  .footer-main .footer-inner {
    flex-direction: column;
    gap: 30px;
  }
  
  .footer-nav {
    gap: 40px;
  }
  
  .footer-subscribe {
    text-align: left;
    width: 100%;
  }
  
  .subscribe-form {
    flex-direction: column;
  }
  
  .email-input {
    width: 100%;
  }
  
  .footer-bottom .footer-inner {
    flex-direction: column;
    gap: 10px;
    text-align: center;
  }
  
  .records {
    flex-wrap: wrap;
    justify-content: center;
  }
}
</style>
